import HeroBasic from '../components/HeroBasic'
import Card from '../components/Card'
import List from '../components/List'
import InfoBox from '../components/InfoBox'
import { useDocs } from 'data/data'

function normalizeRegionValue(regionLabel) {
    return regionLabel.replace('Region ', '').trim().toUpperCase()
}

function countDocsForRegion(docs, regionLabel) {
    let targetRegion = normalizeRegionValue(regionLabel)

    return docs.reduce((count, doc) => {
        let docRegion = doc.region == null ? '' : doc.region.toString().trim().toUpperCase()

        if (docRegion === targetRegion) {
            return count + 1
        }

        return count
    }, 0)
}

function BuildInfoGrid({ docs }) {
    var infoList = [
        {
            header: "Region 1",
            text: (<>
                Boston (serving CT, ME, MA, NH, RI, and VT).
                <br />
                This section focuses on enforcement actions and compliance inspections related to air quality and hazardous waste management in various facilities across Region 1.
            </>),
        },
        {
            header: "Region 2",
            text: (<>
                New York City (serving NJ, NY, Puerto Rico, the U.S. Virgin Islands and 8 federally recognized Indian Nations).
                <br />
                This section focuses on enforcement actions and compliance evaluations related to hazardous waste and air quality regulations in Region 2.
            </>)
        },
        {
            header: "Region 3",
            text: (<>
                Philadelphia (serving DE, DC, MD, PA, VA, WV and 7 federally recognized tribes).
                <br />
                This section focuses on compliance inspections and hazardous waste management in various industries across Region 3, particularly under the Clean Water Act and Resource Conservation and Recovery Act.
            </>)
        },
        {
            header: "Region 4",
            text: (<>
                Atlanta (serving AL, FL, GA, KY, MS, NC, SC, and TN).
                <br />
                This section focuses on enforcement actions, compliance inspections, and information requests related to air quality, water quality, and hazardous waste regulations across the southeastern United States.
            </>)
        },
        {
            header: "Region 5",
            text: (<>
                Chicago (serving IL, IN, MI, MN, OH, and WI).
                <br />
                This section focuses on compliance inspections related to air and water quality regulations across the Great Lakes region, highlighting facility oversight and regulatory compliance activities.
            </>)
        },
        {
            header: "Region 6",
            text: (<>
                Dallas (serving AR, LA, NM, OK, and TX).
                <br />
                Data for Region 6 is currently being processed and will be published in a future release of the Environmental Enforcement Portal.
            </>)
        },
        {
            header: "Region 7",
            text: (<>
                Kansas City (serving IA, KS, MO, and NE).
                <br />
                This section focuses on compliance evaluations and inspections of hazardous waste and air quality regulations across various industries in Region 7, including Iowa, Missouri, Nebraska, and Kansas.
            </>)
        },
        {
            header: "Region 8",
            text: (<>
                Denver (serving CO, MT, ND, SD, UT, and WY).
                <br />
                This section focuses on enforcement actions, compliance inspections, and information requests related to air quality, water quality, hazardous waste, and safe drinking water regulations across the Rocky Mountain region.
            </>)
        },
        {
            header: "Region 9",
            text: (<>
                San Francisco (serving AZ, CA, HI, NV, American Samoa, Commonwealth of the Northern Mariana Islands, Federated States of Micronesia, Guam, Marshall Islands, and Republic of Palau).
                <br />
                This section focuses on enforcement actions and information requests related to air quality, water quality, hazardous waste, and safe drinking water regulations across the western United States and Pacific territories.
            </>)
        },

        {
            header: "Region 10",
            text: (<>
                Seattle (serving AK, ID, OR, WA and 271 native tribes).
                <br />
                This section focuses on environmental compliance and enforcement actions primarily related to water and air quality regulations in Alaska and the Pacific Northwest.
            </>)
        },
        {
            header: "Region HQ",
            text: (<>
                This section contains EPA Headquarters documents that are not associated with a specific regional office. These records include nationally managed enforcement, compliance, and policy-related materials.
            </>)
        },
    ] 

    var infoCards = infoList.map((a, index) => {
        let regionCount = countDocsForRegion(docs, a.header)
        let regionValue = a.header.replace('Region ', '')

        // prepare main content
        const mainContent = a.text ? <p>{a.text}</p> : <List items={a.items} />

        return <InfoBox
            key={index}
            href={`/portal?epaRegion=${encodeURIComponent(regionValue)}`}
            header={
                <span style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '0.75rem'}}>
                    <span>{a.header}</span>
                    <span style={{fontSize: '0.75rem', fontWeight: 700, padding: '0.2rem 0.55rem', borderRadius: '999px', background: '#E7F0FA', color: '#24507A'}}>
                        {regionCount.toLocaleString()} docs
                    </span>
                </span>
            }
        >
            <>
                {mainContent}
            </>
        </InfoBox>
    })

    return <div className="grid">{infoCards}</div>
}

function EPARegions() {
    const { allDocs, isLoading } = useDocs()

    var heroTitle = "EPA Regions"
    var heroSubtitle = "All EPA Regions part of the Eyes on Environmental Enforcement Project."

    var infoGrid = BuildInfoGrid({ docs: isLoading ? [] : allDocs })
    return (
        <div>
            <HeroBasic title={heroTitle} subtitle={heroSubtitle} />
            <Card header="">
                {infoGrid}
            </Card>
        </div>
    )
}

export default EPARegions
